/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Internal_Code_CancelInputs */

const vi_order_internal_code_cancel = /** @type {(inputs: Order_Internal_Code_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huỷ sửa mã đơn nội bộ`)
};

/**

* @param {Order_Internal_Code_CancelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_internal_code_cancel = /** @type {((inputs?: Order_Internal_Code_CancelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Internal_Code_CancelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_internal_code_cancel(inputs)
});